var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.16 27.1172L16 27.2916L15.824 27.1172C8.224 19.6011 3.2 14.6311 3.2 9.59128C3.2 6.10354 5.6 3.48774 8.8 3.48774C11.264 3.48774 13.664 5.23161 14.512 7.60327H17.488C18.336 5.23161 20.736 3.48774 23.2 3.48774C26.4 3.48774 28.8 6.10354 28.8 9.59128C28.8 14.6311 23.776 19.6011 16.16 27.1172ZM23.2 0C20.416 0 17.744 1.41253 16 3.62725C14.256 1.41253 11.584 0 8.8 0C3.872 0 0 4.20272 0 9.59128C0 16.1657 5.44 21.5542 13.68 29.6981L16 32L18.32 29.6981C26.56 21.5542 32 16.1657 32 9.59128C32 4.20272 28.128 0 23.2 0Z",
    fill: "#E82529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.04ee8ee748ae891e35dd08983d435931.svg";
export { ForwardRef as ReactComponent };